import { render, staticRenderFns } from "./CategoryShortcut.vue?vue&type=template&id=7b264399&"
import script from "./CategoryShortcut.vue?vue&type=script&lang=js&"
export * from "./CategoryShortcut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports